<!--suppress ALL -->
<template>
	<div class="history-container full-height"
			 v-if="customerHistory !== null">
        <mq-layout :mq="['xs', 'sm']">
            <img v-on:click="mobileMenuVisible = !mobileMenuVisible"
                 v-if="!mobileMenuVisible"
                 class="history-container__menu-icon"
                 src="../../assets/navbar_mobile.svg">
        </mq-layout>
		<transition name="fade">
			<div class="left-bar" v-if="mobileMenuVisible || ($mq === 'md' || $mq === 'lg' || $mq === 'xl')">
				<mq-layout class="left-bar__back-icon-wrapper visit-section-margin" :mq="['xs', 'sm']">
						<img v-on:click="mobileMenuVisible = !mobileMenuVisible"
									class="left-bar__back-icon"
									src="../../assets/ic_back_arrow.svg">
				</mq-layout>
				<p class="left-bar__title survey-section-margin">{{ $t('patientHistory') }}</p>
				<md-divider class="visits-divider"></md-divider>
				<md-content class="visit-container md-scrollbar ">
					<div v-if="customerHistory">
						<div v-for="(item, index) in customerHistory.bookingList"
								v-bind:key="index"
								v-bind:class="{
								active: (customerHistory.selectedVisit && customerHistory.selectedVisit.id === item.id),
								}"
								class="visit-container__item"
						>
							<div class="bar" @click="onVisitSelect(item)">
								<span class="bar-date">
									{{ getDate(item.booked_from) }}
								</span>
								<span class="bar-name">
									<span class="bar-dot"></span>
									{{generateHeader(item.skeletonElements, false)}}
								</span>
							</div>

							<template
								v-if="customerHistory && customerHistory.selectedVisitForms && customerHistory.selectedVisit.id === item.id"
							>
								<div class="nav">
									<div class="nav-item"
										v-for="(item2, index2) in customerHistory.selectedVisitForms" 
										v-bind:key="index2"
										v-bind:class="{active : item2.isShow}"
										@click="onVisitFormSelect(index2)"
										v-if="item2.isValue"
									>
											<div class="nav-item__icon">
												<img v-bind:src="require('../../assets/' +
													getSurveyIcon(item2.name) +'.svg')">
											</div>
											<span class="nav-item__name">{{ formatSurveyName(item2.name) }}</span>
									</div>
								</div>
							</template>

						</div>
					</div>
				</md-content>
				<md-content class="attachment-container" v-if="customerHistory && customerHistory.attachmentsList.length">
					<div v-on:click="changeAttachmentVisible">
						<div class="left-bar__container">
							<div class="left-bar__title-container">
								<div class="left-bar__counter">{{ customerHistory.attachmentsList.length }}</div>
								<p class="left-bar__title">{{ $t('attachments') }}</p>
							</div>
						</div>
					</div>
				</md-content>
				<!--<md-divider></md-divider>-->
			</div>
		</transition>

		<div class="main-wrapper" v-bind:class="{'blurred': mobileMenuVisible}">

			<template v-if="customerHistory && customerHistory.selectedAttachmentList">
				<div class="visit-header">
					<div class="visit-header__container text-center">
						<span class="float-left">{{ $t('attachmentsList') }}</span>
					</div>
				</div>

				<div class="attachments-list">
					<div v-for="(item, index) in customerHistory.attachmentsList"
							v-bind:key="index"
							class="attachments-list__item">
						<p class="attachments-list__item__title" v-if="item.title">{{item.title}}</p>
						<a v-bind:href="getAttachmentDownloadLink(item.id)" target="_blank">
							<img class="attachments-list__item__att-icon"
										src="../../assets/ic_attachment.svg">
							<span class="attachments-list__item__name">
								{{item.fileName}}
							</span>
							<span class="attachments-list__item__date">
								{{ getFormatedDatetime(item.createdAt) }}
							</span>
						</a>
						<p class="attachments-list__item__description" v-if="item.description">{{item.description}}</p>
					</div>
				</div>
			</template>
			<template v-else-if="customerHistory && customerHistory.selectedVisit">
				<div class="visit-header not-print">
					<div class="visit-header__container text-center clearfix">
						<div class="float-left">
							<div class="head">{{ $t('patient') }}: {{ customerHistory.customer.full_name }}</div>
						</div>
						<mq-layout :mq="['sm', 'md', 'lg', 'xl']">
							<span class="head float-right not-print">
								<img class="visits-printer" 
									v-bind:src="require('../../assets/ic_print.svg')"
									 @click="print"
								>
							</span>
							<span class="head float-right">{{ getDatetime(customerHistory.selectedVisit.booked_from) }}</span>
						</mq-layout>
					</div>
				</div>
				<div class="main-container">
					<div class="main">
						<div class="main-header text-center" v-if="customerHistory && selectedVisitForm && customerHistory.selectedVisit">
							<span class="color-brand">{{generateHeader(customerHistory.selectedVisit.skeletonElements, true)}} </span>
						</div>
						<div class="visit-forms not-print" v-if="customerHistory && selectedVisitForm && customerHistory.selectedVisit">
							<div class="visit-forms-content" v-if="selectedVisitForm.isShow">
								<div class="visit-forms-content__field"
									v-for="(child, index) in selectedVisitForm.children"
									v-bind:key="index" v-bind:field="child">
									<survey-field v-bind:field="child" @nodeChange="onNodeChange"
										v-bind:key="child.id"></survey-field>
								</div>
							</div>
						</div>

						<div class="print" v-if="customerHistory && customerHistory.selectedVisitForms">
							<div class="visit-header__print clearfix">
								<div class="float-left">
									<div class="head">{{ $t('patient') }}: {{ customerHistory.customer.full_name }}</div>
									<div class="head" v-if="customerHistory.customer.gender">{{ $t('gender') }}: {{ gender }}</div>
									<div class="head" v-if="customerHistory.customer.birthday">{{ $t('birthday') }}: {{ customerHistory.customer.birthday }}</div>
									<div class="head" v-if="customerHistory.customer.pesel">{{ $t('pesel') }}: {{ customerHistory.customer.pesel }}</div>
									<div class="head" v-if="customerHistory.customer.address_line_1 || customerHistory.customer.address_line_2">
										{{ $t('streetAddress') }}: {{ customerHistory.customer.address_line_1 }} {{ customerHistory.customer.address_line_2 }}
									</div>
									<div class="head" v-if="customerHistory.customer.city">{{ $t('city') }}: {{ customerHistory.customer.city }}</div>
									<div class="head" v-if="customerHistory.customer.zip_code">{{ $t('postCode') }}: {{ customerHistory.customer.zip_code }}</div>
								</div>
								<mq-layout :mq="['sm', 'md', 'lg', 'xl']">
									<span class="head float-right not-print">
										<img class="visits-printer" 
											v-bind:src="require('../../assets/ic_print.svg')"
											@click="print"
										>
									</span>
									<div v-if="business">
										<div class="float-right business-details" v-for="item in business" :key="item.id">
											<div class="head" v-if="customerHistory.selectedVisit.booked_from">{{ getDatetime(customerHistory.selectedVisit.booked_from) }}</div>
											<div class="head" v-if="item.name">{{ $t('businessName') }}: </div>
											<div class="head" v-if="item.name">{{item.name}}</div>
											<div class="head">
												{{ $t('streetAddress') }}: 
												<div class="head" v-if="item.location.address"> {{item.location.address}}</div>
												<div class="head" v-if="item.location.address2">{{item.location.address2}}</div>
												<div class="head" v-if="item.location.city">{{ $t('city') }}: {{item.location.city}}</div>
												<div class="head" v-if="item.location.zipcode">{{ $t('postCode') }}: {{item.location.zipcode}}</div>										
											</div>
										</div>
									</div>
								</mq-layout>
							</div>
							<div
								v-for="(item, index) in customerHistory.selectedVisitForms"
								v-bind:key="index"
							>
								<div class="pga-always" v-if="item.isValue">
									<p class="print_header">{{ formatSurveyName(item.name) }}</p>
									<div class="visit-forms">
										<div class="visit-forms-content">
											<div class="visit-forms-content__field"
												v-for="(child, index2) in item.children"
												v-bind:key="index2" v-bind:field="child">
												<survey-field v-bind:field="child" @nodeChange="onNodeChange"
													v-bind:key="child.id" v-bind:print="true">
												</survey-field>
											</div>
										</div>
									</div>

									<div 
										v-if="index === (customerHistory.selectedVisitForms.length-1)" 
										class="signature"
									>
										{{ $t('signature') }}
									</div>

								</div>
							</div>
							
						</div>

						<div class="chose-visit-container not-print" v-if="!selectedVisitForm">
							<div>
								<div class="img_list_desktop_container">
										<img class="img_list_desktop_container__arrow" src="../../assets/ic_arrow.svg">
										<img class="img_list_desktop_container__checklist" src="../../assets/Ic_checklist_v2.svg">
								</div>
								<p>Wykonane badania.</p>
							</div>
						</div>
					</div>
				</div>
			</template>

			<template v-else>
				<div class="main-container not-print">
					<div class="spinner-container" v-if="loadingVisit === true">
							<md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
					</div>
					<div class="main">
						<div class="chose-visit-container">
							<div>
									<div class="img_list_desktop_container">
											<img class="img_list_desktop_container__arrow" src="../../assets/ic_arrow.svg">
											<img class="img_list_desktop_container__checklist" src="../../assets/Ic_checklist_v2.svg">
									</div>
									<p v-if="customerHistory && !selectedVisitForm && !customerHistory.selectedVisit">Wybierz wizytę.</p>
							</div>
						</div>
					</div>
				</div>
			</template>

		</div>
	</div>
</template>

<script>
/* eslint-disable no-param-reassign */

import moment from 'moment'
import store from '../../store';
import { 
	CUSTOMER_HISTORY_GET, BODY_PART_DATA_GET, VISIT_SELECT, SURVEY_SELECT,
	VISIT_SELECT_FORMS, CUSTOMER_SET, TOGGLE_VISIT_FORM, SHOW_ONLY_FILLED_SET,
	ATTACHMENT_LIST_SELECT, BUSINESS_DETAILS_GET
} from '../../store/action-modulation.type';

import SurveyService from '../../services/survey.service';
import AuthService from '../../services/auth.service';
import { API_URL } from '../../../config/env';

export default {
  name: 'CustomerHistory',
  data: () => ({
    partData: [],
		mobileMenuVisible: false,
		loadingVisit: false,
	}),
	
  methods: {
		changeAttachmentVisible () {
			store.dispatch(ATTACHMENT_LIST_SELECT);
			if (this.mobileMenuVisible) {
				this.mobileMenuVisible = !this.mobileMenuVisible;
			}
		},

		fetchData() {
			store.dispatch(CUSTOMER_HISTORY_GET, [this.$route.params.businessId, this.$route.params.customerId]);
			store.dispatch(BUSINESS_DETAILS_GET, [this.$route.params.businessId])
		},

		fetchBodyParts() {
			store.dispatch(BODY_PART_DATA_GET).then((data) => {
				store.commit(BODY_PART_DATA_GET, data.data);
				this.partData = store.state.skeleton.partsData;
			});
		},

		getAttachmentDownloadLink(attachmentId) {
			return `${API_URL}appointments/${this.$route.params.visitId}/attachments/${attachmentId}?x-access-token=${AuthService.getToken()}`;
		},

		getFormatedDatetime (date) {
			return moment(date).format("DD.MM.YYYY HH:mm")
		},

		getSurveyIcon(surveyName) {
			switch (surveyName) {
				case 'Wywiad': {
					return 'ic_wywiad';
				}
				case 'przebieg terapii': {
					return 'ic_przebieg_terapi';
				}
				case 'rozpoznania': {
					return 'ic_rozpoznania';
				}
				case 'zalecenia': {
					return 'ic_zalecenia';
				}
				default: {
					return 'ic_entry_incompleted';
				}
			}
		},

		formatSurveyName(name){
			return name.charAt(0).toUpperCase() + name.substring(1);
		},

		onVisitFormSelect(index) {
				store.dispatch(SURVEY_SELECT, this.customerHistory.selectedVisitForms[index]);
				store.dispatch(TOGGLE_VISIT_FORM, index);
				if (this.mobileMenuVisible) {
					this.mobileMenuVisible = !this.mobileMenuVisible;
				}
		},
		onNodeChange() {
		},

		onVisitSelect(item) {
			this.loadingVisit = true;
			store.dispatch(VISIT_SELECT, item);
			store.dispatch(VISIT_SELECT_FORMS, null);
			store.dispatch(SURVEY_SELECT, null);
			SurveyService.getVisitSurveys(item.id)
				.then(s => {
					let forms = s.data.forms;
					s.data.forms.forEach((f, k) => {
						let flag = false;
						if (f.children.length > 0) {
							f.children.forEach((item) => {
								if (this.checkFieldValue(item)) {
									flag = true;
								}
							});
						}
						forms[k].isValue = flag;
						forms[k].isShow = false;
					});

					forms = forms.filter(form => form.isValue)
					store.dispatch(VISIT_SELECT_FORMS, forms);
					this.loadingVisit = false;
				})
		},

		print() {
			window.print();
		},

		generateHeader(skeletonElements, upperCase) {
			let result ='';
			this.partData.forEach((item) => {
				item.children.forEach((child)=>{
					if (skeletonElements.filter(element => element.id === child.id).length > 0 ) {
						result += `${child.name} ${item.name}  | `;
					}
					child.children.forEach((secondChild)=>{
						if (skeletonElements.filter(element => element.id === secondChild.id).length > 0 ) {
							result += `${secondChild.name} ${child.name}  | `;
						}
					})
				})
			});
			if(upperCase) {
				result = result.toUpperCase();
			}
			result = result.slice(0,-2);
			return result;
		},

		getDate(date) {
			return moment(date).format("DD.MM.YYYY");
		},

		getDatetime(date) {
			return moment(date).format("DD.MM.YYYY / HH:mm");
		},

		checkFieldValue(field) {
			let flag = false;
			if ((field.value !== undefined) && (field.value !== null) && (field.value !== '')) {
				flag = true;
				if (field.type === 'RECOGNITIONS') {
					const fieldValue = JSON.parse(field.value);
					if (fieldValue.recognitions[0].recognition || fieldValue.recognitions[0].comments) {
						flag = true;
					} else {
						flag = false;
					}
				} else if (field.type === 'EXERCISES') {
					const fieldValue = JSON.parse(field.value);
					if (fieldValue.exercises[0].name || fieldValue.exercises[0].series || fieldValue.exercises[0].count || fieldValue.exercises[0].comments) {
						flag = true;
					} else {
						flag = false;
					}
				} else if (field.type === 'CHECKBOX') {
					if (field.value === '0') {
						flag = false;
					} else {
						flag = true;
					}
				}
			}

			if (field.children.length > 0) {
				field.children.forEach((item) => {
					if (this.checkFieldValue(item)) {
						flag = true;
					}
				});
			}
			return flag;
		},
	},
	
  computed: {
		customerHistory() {
      return store.state.customerHistory;
		},
		
    business() {
      return store.state.business;
		},
		
    selectedVisitForm() {
      return store.state.visit.selectedSurvey;
    },

		gender() {
			switch (this.customerHistory.customer.gender) {
				case 'M': {
					return this.$t('male');
				}
				case 'F': {
					return this.$t('female');
				}
				default: {
					return '';
				}
			}
		}
	},

  created() {
		store.dispatch(SHOW_ONLY_FILLED_SET, true);
    this.fetchBodyParts();
		this.fetchData();
  },
};
</script>

<style src="./CustomerHistory.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CustomerHistory/CustomerHistory.vue